export default __webpack_public_path__ + "static/media/user_plataforma.898669c6.csv";